import React, {useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText} from "@material-ui/core";
import { ApplicationUser } from '../../../entities/ApplicationUser';
import { AdminService } from '../../../services/AdminService';
import { ServerResponse } from '../../../services/server/OldWebClient';
import { useAuthenticatedUser } from '../../../utilities/useAuthenticatedUser';

interface Props {
    openRefundDialog: boolean;
    toggleRefundDialog: () => void;
    onSubscriptionChanged: (updatedUser:ApplicationUser) => void;
    toggleShowErrorMessage: () => void;
    setErrorMessage: (message:string) => void;
}

export function RefundSubscriptionDialog(props:Props) {
    const { openRefundDialog, toggleRefundDialog, onSubscriptionChanged, setErrorMessage, toggleShowErrorMessage } = props;
    const user = useAuthenticatedUser();
    const [disabled, setdisabled] = useState<boolean>(false);

    const onRefundSubscription = async () => {
        setdisabled(true);

        let applicationUserResponse = await AdminService.cancelAndRefundMakerSubscription();
        if (ServerResponse.isSuccess(applicationUserResponse)) {
            onSubscriptionChanged(applicationUserResponse.data);
        } else if(ServerResponse.isError(applicationUserResponse)){
            setErrorMessage(applicationUserResponse.message)
            toggleShowErrorMessage();
        }     
        
        setdisabled(false);
        toggleRefundDialog()
    }

    return (
        <Dialog open={openRefundDialog} onClose={toggleRefundDialog} >
        <DialogTitle>Cancel {`${user.firstName} ${user.lastName}`}'s Sermon Maker Subscription?</DialogTitle>
        <DialogContent>
            <DialogContentText>Are you sure you want to cancel and refund this subscription?</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={toggleRefundDialog} disabled={disabled} color="primary">
                No
            </Button>
            <Button onClick={onRefundSubscription} disabled={disabled} color="primary">
                Yes
            </Button>
        </DialogActions>
    </Dialog>
    );
}